import {
  EmptyStateWithIllustration,
  EmptyStateImage,
} from 'components/EmptyState'

const DocumentEmptyState = () => {
  return (
    <EmptyStateWithIllustration
      title="Belum ada dokumen"
      description="Silakan coba lagi dalam beberapa saat."
      className="w-full py-16 text-center"
      fullscreen={false}
    >
      <EmptyStateImage imageSrc="/illustrations/img-empty-document-2.png" />
    </EmptyStateWithIllustration>
  )
}

export default DocumentEmptyState
